export default {
  computed: {
    shouldHideAllCompsButton () {
      return this.$route.name === 'competitions'
    }
  }
}
